import * as React from 'react'
import g from 'glamorous'
import { RouteComponentProps } from 'react-router'
import { adopt } from 'react-adopt'

import Navbar from '../components/Navbar'
import LoanQuery from '../components/queries/LoanQuery'
import Loading from '../components/Loading'
import Detail from './loanDetail/Detail'
import MeQuery from '../components/queries/MeQuery'
import { GetChildrenRenderProp } from '../types'
import CloseLoanMutation from '../components/mutations/CloseLoanMutation'
import { loanQueries } from '../utils/refetchQueries'
import { UserRole } from '../graphql/queries/me'

const StyledContainer = g.div(({ theme }) => {
  return {
    maxWidth: '1200px',
    width: '100%',
    margin: '0 auto'
  }
})

interface ComposedProps {
  loanId: string
  isAdmin: boolean
}

interface RenderProps {
  loan: GetChildrenRenderProp<typeof LoanQuery>
  closeLoan: () => Promise<void>
}

const Composed = adopt<RenderProps, ComposedProps>({
  loan: ({ render, loanId }) => (
    <LoanQuery variables={{ id: loanId }}>
      {data => render && render(data)}
    </LoanQuery>
  ),
  closeLoan: ({ render, loanId, isAdmin }) => (
    <CloseLoanMutation>
      {closeLoan =>
        render &&
        render(async () => {
          const result = await closeLoan({
            variables: { id: loanId },
            refetchQueries: loanQueries(isAdmin)
          })

          if (result == null || result.data == null) {
            return
          }
        })
      }
    </CloseLoanMutation>
  )
})

export type LoanDetailProps = RouteComponentProps<{ id: string }>

const LoanDetail: React.SFC<LoanDetailProps> = props => {
  return (
    <div>
      <Navbar />
      <StyledContainer>
        <MeQuery>
          {me => (
            <Composed
              loanId={props.match.params.id}
              isAdmin={
                me.data != null &&
                me.data.user.roles.indexOf(UserRole.ADMIN) !== -1
              }
            >
              {({ closeLoan, loan }) => {
                if (loan.loading || me.loading) {
                  return <Loading />
                }

                if (
                  loan.error != null ||
                  me.error != null ||
                  loan.data == null ||
                  me.data == null
                ) {
                  return <div>Error</div>
                }

                if (loan.data.loan == null) {
                  return <div>Not found</div>
                }

                return (
                  <Detail
                    loan={loan.data.loan}
                    closeLoan={closeLoan}
                    user={me.data.user}
                  />
                )
              }}
            </Composed>
          )}
        </MeQuery>
      </StyledContainer>
    </div>
  )
}

export default LoanDetail



// WEBPACK FOOTER //
// ./src/screens/LoanDetail.tsx